<script>
import NewTable from '../layouts/Table'
import { mapGetters , mapActions } from 'vuex';
import {ReportService} from "@/services/ReportService";
import {AlertService} from "@/services/AlertService";
import BaseModal from "@/components/common/BaseModal.vue";
import InputFile from "@/views/InputFile.vue";
import contactList from "@/components/contact-list/ContactList.vue";
import {permissionMixin} from "@/mixins/permissionMixins";
export default {
  name: "ContactListIndex",
  components : {
    'new-table' : NewTable,
    BaseModal,
    InputFile
  },
  mixins:[
    permissionMixin
  ],
  data(){
    return{
      filter_inputs:{
        selected_contact:null,
        selected_fleet:null
      },
      form_inputs:{
        selected_contact:null,
        selected_fleet:null,
        selected_file:null,
        selected_date:null,
      },
      fleetContactLists : [],
      allContactList: [],
      fleet_contact_list_name:"",
      show_upload_modal:false,
      categoryList: { krbs:'KRBS' , em:'Emergency' }

    }
  },
  async created(){
      await this.initializeGetters();
  },
  computed:{
    contactList() {
      return contactList
    },
    ...mapGetters([
      'fleetKeys',
    ]),
    canUpload(){
      const hasFleet = this.form_inputs.selected_contact ? (this.form_inputs.selected_fleet !== null) : true;
      return this.form_inputs.selected_file !== null && this.form_inputs.selected_date !== null && hasFleet;
    },
    cantUploadBtn(){
      return !this.filter_inputs.selected_contact ? false : ( this.filter_inputs.selected_fleet === null)
    }
  },
  methods:{
    ...mapActions([
      'getFleetListKeys',
    ]),
    resetFleet(){
      this.filter_inputs.selected_fleet = null
    },
    async resetAllInputs(closeModal = false){
      let action = true;
      if(closeModal){
        if(this.form_inputs.selected_file || this.form_inputs.selected_date){
          action = await AlertService.cancelChanges();
        }
        if(!action){
          return false;
        }
        this.show_upload_modal = false;
      }
      Object.assign(this.form_inputs,{
        selected_contact:null,
        selected_fleet:null,
        selected_file:null,
        selected_date:null
      });
    },
    async initializeGetters(){
      await this.getFleetListKeys();
      this.fleetContactLists = await ReportService.getFleetContactLists();
      this.allContactList = this.fleetContactLists
      this.handleFilter();
    },
    async uploadContactList() {
      if(!this.canUpload){
        AlertService.warningAlert('Please complete the required fields.','Required Fields');
        return false;
      }
      const action = await AlertService.confirmCreateAlert('Are you sure you want to upload this file?','Yes, upload it!');
      if (!action){
        return false;
      }
      let formData = new FormData();
      let file = this.form_inputs.selected_file;
      formData.append('file', file);
      formData.append('file_date', this.form_inputs.selected_date);
      formData.append('file_category',this.filter_inputs.selected_contact);
      formData.append('file_fleet',this.filter_inputs.selected_fleet);

      const uploadResult = await ReportService.uploadContactFile(formData);
      if (uploadResult.result === true) {
        AlertService.successAlert(`New Fleet Contact List has been created`, 'UPLOADING FLEET CONTACT LIST');

        await this.resetAllInputs();
        await this.initializeGetters();
        this.show_upload_modal = false;
      }
    },
    async deleteContactList(fileName) {
      if (await AlertService.confirmDeleteAlert('DELETION OF CONTACT LIST', 'Do you want to Delete this Contact Record?', 'Yes, Proceed!')) {
        let deleteRequest = await ReportService.deleteFleetContactList({
          file_name : fileName
        });
        if (deleteRequest.result === true) {
          await this.initializeGetters();
        }
      }
    },
    async getContactUploadedFile(fileName){
      await AlertService.loading();
      let fleetContactFile = await ReportService.getContactFile(fileName);
      swal.close();
      fleetContactFile = window.URL.createObjectURL(new Blob([fleetContactFile], {type: 'application/pdf'}))
      swal.fire({
        title: ``,
        allowOutsideClick: true,
        allowEnterKey: false,
        allowEscapeKey: true,
        width: '1280px',
        confirmButtonColor: '#056cb4',
        'html': `<iframe src="${fleetContactFile}"   style="width: 100%; height: 70vh;" frameborder="0" />`
      })
    },
    handleFilter(column = 'category'){
      if(column === 'category'){
        this.resetFleet()
      }
      this.fleetContactLists = this.allContactList.filter( contacts => {
        const hasAllCategory = contacts?.fileCategory === null && contacts?.fleet === null;
        let categoryCondition = contacts?.fileCategory === this.filter_inputs.selected_contact;
        let fleetCondition =  contacts?.fleet === this.filter_inputs.selected_fleet;

        if(!this.filter_inputs.selected_contact){
          return hasAllCategory;
        }
        if(this.filter_inputs.selected_fleet){
          return categoryCondition && fleetCondition;
        }
        return categoryCondition ;
      });

    },
    setDateFormat(givenDate){
      const date = new Date(givenDate);
      const dateFormatter = new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      });
      const timeFormatter = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
      return  `${dateFormatter.format(date)} ${timeFormatter.format(date)}`;
    }
  },

}
</script>

<template>
  <div class="row">
    <div class="col-xl-3 col-lg-12 text-left">
      <h3 class="text-left ml-4">Contact List</h3>
    </div>
    <div class="col-xl-9 col-lg-12 d-flex justify-content-end flex-wrap gap-4 align-items-center mb-2">
      <select class="form-control form-control-sm w-auto ml-3  "  v-model="filter_inputs.selected_contact"  @change="handleFilter('category')">
        <option :value="null">ALL</option>
        <option :value="'krbs'" class="bg-light">KRBS</option>
        <option :value="'em'" class="bg-light">Emergency</option>
      </select>
      <select class="form-control form-control-sm  w-25  mx-2 "  v-model="filter_inputs.selected_fleet" :disabled="filter_inputs.selected_contact === null"  @change="handleFilter">
        <option :value=null> - SELECT FLEET - </option>
        <option  :key="fleet.id" class="text-uppercase" v-for="fleet in fleetKeys" v-if="filter_inputs.selected_contact !== null ">
          {{ fleet.name ? fleet.name.toUpperCase() : ''}}
        </option>
      </select>
      <button class="e-btn e-btn-green  e-text-white "  v-if="isElite()" :class="{ 'cursor-not-allowed' : cantUploadBtn , 'e-btn-green-disabled' : cantUploadBtn }"  @click="show_upload_modal = true" :disabled="cantUploadBtn" :title="cantUploadBtn ? 'Choose a fleet' : '' " >
        <font-awesome-icon icon="folder-plus" style="width: 25px" />
        <small class="font-weight-bold">
          UPLOAD NEW FILE
        </small>
      </button>
    </div>
    <BaseModal :is-visible="show_upload_modal" size="md" :close-button="false" @close="show_upload_modal = false">
        <template v-slot:title>Upload File</template>
        <template v-slot:body>
          <div class="container">
            <div class="form-group row mb-0 pb-0">
              <label for="" class="font-weight-bold col-sm-3 col-form-label">Document <span class="e-text-red">*</span></label>
              <div class="col-lg-9">
                <InputFile size="sm" v-model="form_inputs.selected_file" :is-input-file="false"/>
              </div>
            </div>
            <div class="form-group row mb-2">
              <label for="" class="font-weight-bold col-sm-3 col-form-label">Date <span class="e-text-red">*</span></label>
              <div class="col-lg-9">
                <input type="date" min="1900-01-01" v-model="form_inputs.selected_date" class="form-control form-control-sm px-1 py-1">
              </div>
            </div>
            <div class="form-group row mb-0 mt-1">
              <label for="" class="font-weight-bold col-sm-3 col-form-label py-0">Category </label>
              <div class="col-lg-9">
                  <label for="" style="font-size: .875rem;" class="mb-0 pb-0">
                    {{ categoryList[filter_inputs.selected_contact] ?? 'ALL' }}
                  </label>
              </div>
            </div>
            <div class="form-group row mb-0 mt-1" v-if="filter_inputs.selected_contact">
              <label for="" class="font-weight-bold col-sm-3 col-form-label py-0">Fleet </label>
              <div class="col-lg-9">
                <label for="" style="font-size: .875rem;" class="mb-0 pb-0">
                  {{ filter_inputs.selected_fleet }}
                </label>
              </div>
            </div>

          </div>
        </template>
      <template v-slot:footer>
<!--        <button type="button" class="e-btn e-btn-yellow" @click="resetAllInputs(false)">RESET</button>-->
        <button type="button" class="e-btn e-btn-blue-gray" @click="resetAllInputs(true)">Close</button>
        <button class="e-btn e-btn-blue" id = "uploadTest" :class="{ 'e-btn-blue-disabled' : !canUpload }"  @click.prevent="uploadContactList" :disabled="!canUpload" >Upload</button>
      </template>
    </BaseModal>

    <div class="col-lg-12 table-responsive  contact-table" >
      <new-table>
        <template v-slot:table-header>
          <tr style="height: 46.28px">
            <!--            <th class="align-middle text-center">File</th>-->
            <th class="align-middle text-center">File Name</th>
            <th class="align-middle text-center">File Date</th>
            <th class="align-middle text-center">Category</th>
            <th class="align-middle text-center" v-if="filter_inputs.selected_contact !== null ">Fleet</th>
            <th class="align-middle text-center">Date Uploaded</th>
            <th class="align-middle text-center">Action</th>
          </tr>
        </template>
        <template v-slot:table-body>
          <template v-if="fleetContactLists.length > 0">
            <tr style="height: 41.5px" v-for="list in fleetContactLists">
              <!--              <td class="align-middle text-center">-->
              <!--                <font-awesome-icon icon="file-pdf" class="force-danger-all" size="3x" style="cursor: pointer"></font-awesome-icon>-->
              <!--              </td>-->
              <td class="align-middle text-center">{{ list.file_name }}</td>
              <td class="align-middle text-center">{{ list.formatted_date }}</td>
              <td class="align-middle text-center">{{ categoryList[list.fileCategory] ?? 'ALL' }}</td>
              <td class="align-middle text-center" v-if="filter_inputs.selected_contact !== null ">{{ list.fleet ?? '' }}</td>
              <td class="align-middle text-center">{{ setDateFormat(list.file_created) }}</td>
              <td class="align-middle text-center">
                <div class="dropdown dropright" >
                  <button
                    id="actionDropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="mr-2 btn btn-sm btn-secondary force-white-all"
                    data-toggle="dropdown"
                  >
                    <font-awesome-icon icon="cogs"/>
                  </button>
                  <div aria-labelledby="actionDropdown" class="dropdown-menu py-0">
                    <button class="dropdown-item text-secondary font-weight-bolder"
                            @click="getContactUploadedFile(list.file_name)"
                    >
                      <font-awesome-icon icon="eye"/>
                      View
                    </button>

                    <button class="dropdown-item text-secondary font-weight-bolder text-danger"
                            @click="deleteContactList(list.file_name)"
                            v-if="isElite()"
                    >
                      <font-awesome-icon icon="trash" class="e-text-red"/>
                      Delete
                    </button>
                  </div>
                </div>

              </td>
            </tr>
          </template>
          <template v-else>
            <tr class="text-uppercase" style="height: 41.5px">
              <td class="align-middle text-center" colspan="100%">No Data</td>
            </tr>
          </template>
        </template>
      </new-table>
    </div>
  </div>
</template>

<style scoped>
.border-red{
  border:1px solid red;
}
.contact-table{
  position: relative;
  height: 80vh;
  min-width:900px;
}
.contact-table table th{
  position: sticky;
  top:0;
  left:0;
  z-index: 99;
}
</style>
